import * as React from "react";
import {
    Edit,
    FormDataConsumer,
    ReferenceArrayInput,
    SelectArrayInput,
    SelectInput,
    SimpleForm,
    TextInput,
    useNotify, useRecordContext
} from 'react-admin';
import dataProvider from "../dataProvider";

const AdministratorForm = () => {
    const notify = useNotify();
    const record = useRecordContext();
    return <SimpleForm onSubmit={async (values) => {
        const neededValues = {
            name: values.name,
            email: values.email,
            roleType: values.roleType,
            accessedEmployerIds: values.roleType === 'Regular' ? values.accessedEmployerIds : [],
        }
        await dataProvider.update('administrator', {
            id: record.id,
            data: neededValues
        }).then(res => {
            if (res.data) {
                notify(`Sikeres módosítás`, {type: 'success'});
            } else {
                notify(`Hiba történt`, {type: 'error'});
            }
        })
    }
    }>
        <TextInput source="name" label={"Név (kötelező)"} name={"name"} required fullWidth/>
        <TextInput source="email" label={"E-mail (kötelező)"} name={"email"} required fullWidth disabled/>
        <SelectInput source="roleType" label={"Hozzáférés (kötelező)"}
                     fullWidth
                     required
                     defaultValue={'Regular'}
                     choices={[
                         {id: 'Regular', name: 'Általános'},
                         {id: 'Super', name: 'Szuper admin'},
                     ]}/>
        <FormDataConsumer>
            {({formData, ...rest}) => {
                if (formData.roleType === 'Regular') {
                    return <ReferenceArrayInput name={"accessedEmployerIds"} source="accessedEmployerIds"
                                                reference="employer">
                        <SelectArrayInput fullWidth placeholder={'Projekt'} label={'Projekt hozzáférés'}/>
                    </ReferenceArrayInput>
                }
            }
            }
        </FormDataConsumer>
    </SimpleForm>
}

export const AdministratorEdit = () => (
    <Edit title={'Felhasználó szerkesztése'}>
        <AdministratorForm/>
    </Edit>
);